'use strict';

/**
 *
 * @name: SeasonsConfig
 *
 */

function SeasonsConfig($stateProvider) {

  'ngInject';

  function _resolveModuleControllers($ocLazyLoad) {

    return $ocLazyLoad.load('SeasonsBundle');
  }

  $stateProvider
    .state('main.seasons', {
      url: 'seasons',
      controller: 'SeasonsLandingController',
      templateProvider: $templateCache => $templateCache.get('seasons-landing.index.html'),
      resolve: {
        moduleControllers: _resolveModuleControllers
      }
    })
    .state('main.seasonsSingle', {
      url: 'seasons/:slug/:postSlug',
      params: {
        postSlug: {
          value: null,
          squash: true
        },
        slug: {
          value: null
        }
      },
      controller: 'SeasonsSingleController',
      templateProvider: $templateCache => $templateCache.get('seasons-single.index.html'),
      resolve: {
        moduleControllers: _resolveModuleControllers
      }
    });
}

export default SeasonsConfig;



// WEBPACK FOOTER //
// ./app/pages/seasons/seasons.config.js